export default "__VITE_ASSET__BGo$XcwH__"